// The webapp's per-stage config (TT-1248): the Cognito user pool, its web
// client and appback's URL. All three are public: the client has no client
// secret, and the build inlines them into the bundle anyway. They are
// committed here so no build and no checkout reads AWS for them; the
// platform's /vt/<stage>/infra/cognito and /vt/<stage>/vtap/appback/URL hold
// the same values. The stage is REACT_APP_STAGE (amplify.yml sets it by
// branch); a local run is dev.

const STAGES = {
  dev: {
    userPoolId: "us-west-2_GYo3Ypird",
    userPoolWebClientId: "2v5rr9advjaqlpkg1vf4905vgb",
    appbackUrl: "https://appback-dev.tapestryai.com",
  },
  prod: {
    userPoolId: "us-west-2_5XPAGICJY",
    userPoolWebClientId: "1u0uclgctd72amlk2792l8tua3",
    appbackUrl: "https://appback-prod.tapestryai.com",
  },
};

export const STAGE = process.env.REACT_APP_STAGE === "prod" ? "prod" : "dev";

const stageConfig = STAGES[STAGE];

export default stageConfig;
